import { MessageCircle, Send, Instagram, ArrowUpRight } from "lucide-react";
import { useSite } from "../../context/SiteContext";
import { Reveal } from "./Reveal";

export default function Footer({ go }) {
  const { contact: CONTACT, trial } = useSite();
  const CH = [
    { id: "whatsapp", icon: MessageCircle, label: "WhatsApp", value: CONTACT.whatsappDisplay, href: CONTACT.whatsapp },
    { id: "telegram", icon: Send, label: "Telegram", value: CONTACT.telegramDisplay, href: CONTACT.telegram },
    { id: "instagram", icon: Instagram, label: "Instagram", value: CONTACT.instagramDisplay, href: CONTACT.instagram },
  ];
  return (
    <footer id="iletisim" className="relative bg-[#0d0b3d] pt-24 md:pt-32 pb-10 overflow-hidden" data-testid="footer">
      <div className="absolute -bottom-40 left-1/2 -translate-x-1/2 h-[30rem] w-[30rem] rounded-full moon opacity-25" />
      <div className="relative mx-auto max-w-7xl px-5 md:px-10">
        <Reveal>
          <p className="text-sm md:text-base font-semibold uppercase tracking-[0.3em] text-[#a4a6ff] mb-5">İletişim</p>
          <h2 className="font-display text-4xl sm:text-6xl lg:text-7xl font-extrabold uppercase leading-[0.95]" data-testid="footer-title">
            Dolunay TV<br /><span className="text-[#8a8dff]">İletişim Kanallarımız</span>
          </h2>
          <p className="mt-6 max-w-xl text-base md:text-lg text-[#c9c6f0]">Sipariş, ücretsiz test ve kurulum desteği için bize dilediğin kanaldan ulaş.</p>
          <a href={trial} target="_blank" rel="noreferrer" data-testid="footer-trial-btn"
            className="group mt-8 inline-flex items-center gap-2 rounded-full bg-white px-6 py-3.5 font-semibold text-[#0d0b3d] hover:bg-[#5b5fd6] hover:text-white transition-colors">
            6 Saat Ücretsiz Test İste <ArrowUpRight size={18} className="transition-transform group-hover:rotate-45" />
          </a>
        </Reveal>
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-4">
          {CH.map((c, i) => (
            <Reveal key={c.id} delay={i * 0.08}>
              <a href={c.href} target="_blank" rel="noreferrer" data-testid={`footer-${c.id}-link`}
                className="group flex items-center gap-4 rounded-[24px] border border-white/10 bg-[#13114f]/70 backdrop-blur p-6 hover:border-[#8a8dff] hover:bg-[#5b5fd6] transition-colors">
                <span className="grid h-12 w-12 place-items-center rounded-2xl bg-white/10"><c.icon size={20} /></span>
                <span className="min-w-0">
                  <span className="block text-xs uppercase tracking-widest text-[#c9c6f0] group-hover:text-white">{c.label}</span>
                  <span className="block font-semibold text-lg truncate">{c.value}</span>
                </span>
              </a>
            </Reveal>
          ))}
        </div>
        <div className="mt-20 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 border-t border-white/10 pt-8">
          <a href="#top" onClick={(e) => { e.preventDefault(); go("#top"); }} data-testid="footer-logo">
            <img src="/img/logo-t.png" alt="Dolunay TV" className="h-12 w-auto" />
          </a>
          <p className="text-sm text-[#c9c6f0]">© {new Date().getFullYear()} Dolunay TV. Tüm hakları saklıdır.</p>
        </div>
      </div>
    </footer>
  );
}
